import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChatJamarbotComponent } from './chat-jamarbot/chat-jamarbot.component';

const routes: Routes = [
 /*  {
    path: '',
    redirectTo: 'chat-jamarbot',
    pathMatch: 'full'
  }, */
  {
    path: 'chat-jamarbot',
    component: ChatJamarbotComponent,
    /* data: { 
      title: 'JamarBot - Asistente Virtual',
      breadcrumb: 'Chat'
    } */
  },
  { path: '', redirectTo: 'procesos', pathMatch: 'prefix' },
  { path: '**', redirectTo: 'procesos', pathMatch: 'prefix' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProcesosRoutingModule { }